import React, { useState, useEffect } from 'react';
import Slider from 'rc-slider';
import './App.css'
import 'rc-slider/assets/index.css';
import SelectReact from './SelectReact.js'
import Flag from 'react-world-flags';
import Modal from './Modal.js'

const CurrencyConverter = () => {
  const [amount, setAmount] = useState(0);
  let [fromCurrency, setFromCurrency] = useState('USD');
  let [toCurrency, setToCurrency] = useState('EUR');
  const [convertedAmount, setConvertedAmount] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [showModal, setShowModal] = useState(false);



  useEffect(() => {
    fetch(`https://api.exchangerate-api.com/v4/latest/${fromCurrency}`)
      .then(res => res.json())
      .then(data => {
        setExchangeRate(data.rates[toCurrency]);
        console.log(data.rates);
        console.log("from: " + fromCurrency);
        console.log("to: " + toCurrency);
      })
      .catch(error => {
        console.log(error);
      });
    setExchangeRate(0)
  }, [fromCurrency, toCurrency]);

  const handleAmountChange = (e) => {
    setAmount(e);
    if (fromCurrency !== 0) {
      setConvertedAmount((e * exchangeRate).toFixed(2));
    } else {
      setConvertedAmount(0);
      toCurrency(0)
    }
  };

  const handleFromCurrencyChange = (e) => {
    console.log("handle from currency change");
    setFromCurrency(e.value);
    if (fromCurrency !== 0) {
      setConvertedAmount((amount * exchangeRate).toFixed(2));
      console.log("amount: " + amount);
    } else {
      setConvertedAmount(0);
    }
  };

  const handleToCurrencyChange = (e) => {
    setToCurrency(e.value);
    if (fromCurrency !== 0) {
      setConvertedAmount((amount * exchangeRate).toFixed(2));
      console.log("from currency amount: " + amount);
    } else {
      setConvertedAmount(0);
    }
  };
  const handleSelectFocus = (e) => {
    e.target.blur();
  }

  return (
    <div className="container">
      <div className="top-half">
        <div className="top-select">
          <SelectReact menuPlacement="top" readonly onChange={handleFromCurrencyChange} placeholder="USD" onFocus={handleSelectFocus} />
        </div>

        <div className="top-slider">
          <Slider keyboard={true} defaultValue={0} min={0} step={10} max={1000} onChange={handleAmountChange} tipFormatter={value => `${value} ${fromCurrency}`} />
        </div>
        <h1 className="amount-from">{amount}</h1>
      </div>
      <div className="switch-top">
        <Modal show={showModal} handleClose={() => setShowModal(false)} />
      </div>

      <div className="bottom-half">
        <div className="switch-bottom">
          <Modal show={showModal} handleClose={() => setShowModal(false)} />
        </div>
        <div className="bottom-slider">
          <Slider defaultValue={0} min={0} step={10} max={1000} onChange={handleAmountChange} tipFormatter={value => `${value} ${fromCurrency}`} />
        </div>
        <div className="bottom-select">
          <SelectReact className="bottom-selecter" onFocus={handleSelectFocus} readonly defaultValue="EUR" placeholder={
            <>
              <Flag code={toCurrency} height="16" />
              {'EUR'}
            </>
          } onChange={handleToCurrencyChange} />
        </div>
        <h1 className="amount-to">{Math.floor(convertedAmount)}</h1>
      </div>
    </div>
  );
};


export default CurrencyConverter;
